export const iconFontAwesomeUsersPeoplePersonDrowning = (
	<i className="fa-solid fa-person-drowning"></i>
);
